<div class="breadcrumb-area">
	<h1>Familias</h1>
</div>
<div class="card mb-5">
	<div class="card-header">
		<h3>Administración de Familias de Producto <a (click)="creating = true" *ngIf="!creating"><i
					class="a-hover fa fa-plus"></i></a></h3>
	</div>
	<div class="card-body">
		<p class="text-muted">Una familia se encuentra activa si el icono <i class="fa fa-power-off"></i> se encuentra
			en color <span style="font-weight: 900;color: green;">verde</span>. Activa o desactiva la familia dando
			click sobre el icono antes mencionado. Para las subfamilias, haz click primero en el botón de editar, luego
			guarda los cambios</p>
		<div class="row">
			<div class="col-sm-4 new-family" *ngIf="creating">
				<h4 id="pin-container">Crea una familia<i (click)="alwaysCreating=!alwaysCreating"
						[class.opacity-20]="!alwaysCreating" class="fa fa-thumbtack"></i></h4>
				<span>Datos de la familia</span>
				<div class="input-group input-group-sm">
					<label for="name-family" class="input-group-text">Nombre</label>
					<input type="text" name="name-family" [(ngModel)]="newCategory.name" id="name-family"
						class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="description-family" class="input-group-text">Descripción</label>
					<textarea [(ngModel)]="newCategory.description" name="description-family" id="description-family"
						class="form-control"></textarea>
				</div>
				<span>Agrega subfamilias</span>
				<div class="input-group input-group-sm">
					<label for="name-subfamily" class="input-group-text">Nombre</label>
					<input type="text" name="name-subfamily" [(ngModel)]="newCategoryChild.name" id="name-subfamily"
						class="form-control">
				</div>
				<div class="input-group input-group-sm">
					<label for="description-subfamily" class="input-group-text">Descripción</label>
					<textarea [(ngModel)]="newCategoryChild.description" name="description-subfamily"
						id="description-subfamily" class="form-control"></textarea>
					<button class="btn btn-primary" [disabled]="!newCategoryChild.name" (click)="addCategoryChild()"><i
							class="fa fa-plus"></i></button>
				</div>
				<div class="container-subfamily">
					<ng-container *ngFor="let newChild of newCategoryChildren; let i = index">
						<span class="category-child-item">{{newChild.name}} <i class="a-hover fa fa-xmark"
								(click)="deleteNewCategoryChild(i)"></i> </span>
					</ng-container>
				</div>
				<div class="button-container">
					<button class="btn btn-danger" (click)="cancelNewFamily()"><i
							class="fa fa-xmark"></i>CANCELAR</button>
					<button class="btn btn-primary" (click)="addNewFamily()" [disabled]="!newCategory.name"><i
							class="fa fa-floppy-disk"></i>GUARDAR</button>
				</div>
			</div>
			<div [ngClass]="creating?'col-sm-8':'col'">
				<div class="table table-responsive">
					<table class="table">
						<thead>
							<tr>
								<th class="ta">
									Estado
								</th>
								<th>
									Nombre
								</th>
								<th>
									Descripción
								</th>
								<th>
									Subfamilias
								</th>
								<th class="ta">
									Opción
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let category of categories">
								<tr [class.tr-hide]="edit!=0 && edit!=category.id">
									<td class="ta">
										<i (click)="activeOrInactive(category)" class="status-category fa fa-power-off"
											[class.active-category]="category.active"></i>
									</td>
									<td>
										<ng-container *ngIf="edit!=category.id">
											{{category.name}}
										</ng-container>
										<ng-container *ngIf="edit==category.id">
											<input type="text" name="name-edit-family" [(ngModel)]="category.name"
												id="name-edit-family" class="form-control">
										</ng-container>
									</td>
									<td>
										<ng-container *ngIf="edit!=category.id">
											<span *ngIf="category.description">
												{{category.description}}
											</span>
											<span *ngIf="!category.description" class="opacity-30">
												<i class="fa fa-circle-info"></i> Sin descripción.
											</span>
										</ng-container>
										<ng-container *ngIf="edit==category.id">
											<textarea name="description-edit-family" [(ngModel)]="category.description"
												id="description-edit-family" class="form-control"></textarea>
										</ng-container>
									</td>
									<!-- <td *ngIf="category.children.length == 0">
										
									</td> -->
									<td>
										<table class="table table-bordered table-subfamilies">
											<thead>
												<tr class="updown" *ngIf="category.children.length >0"
													(click)="categorySelected = categorySelected ==category.id?null:category.id">
													<th colspan="3">
														<span><i class="fa"
																[ngClass]="category.id==categorySelected?'fa-chevron-up':'fa-chevron-down'"></i>{{category.id==categorySelected?'Comprimir':'Desplegar'}}
															{{category.children.length}} subfamilias</span>
													</th>
												</tr>
												<tr *ngIf="category.children.length == 0 && edit != category.id"
													style="font-size: 1em;border: none;">
													<th style="border: none;">
														<span class="opacity-30"><i class="fa fa-circle-info"></i> La
															familia no cuenta
															con
															subfamilias</span>
													</th>
												</tr>
												<tr
													*ngIf="categorySelected == category.id && category.children.length != 0">
													<th class="td-center">
														Estado
													</th>
													<th>
														Nombre
													</th>
													<th>Descripción</th>
												</tr>
											</thead>
											<tbody *ngIf="categorySelected == category.id">
												<tr *ngFor="let child of category.children">
													<ng-container *ngIf="category.id!=edit">
														<td class="td-center">
															<i class="status-category fa fa-power-off"
																[class.active-category]="child.active"></i>
														</td>
														<td>
															{{child.name}}
														</td>
														<td>
															{{child.description}}
														</td>
													</ng-container>
													<ng-container *ngIf="category.id==edit">
														<td class="td-center">
															<i (click)="child.active = !child.active"
																class="status-category fa fa-power-off"
																[class.active-category]="child.active"></i>
														</td>
														<td>
															<input type="text" id="nameSubfamily" name="nameSubfamily"
																class="form-control" [(ngModel)]="child.name">
														</td>
														<td>
															<input type="text" id="descriptionSubfamily"
																[(ngModel)]="child.description"
																name="descriptionSubfamily" class="form-control">
														</td>
													</ng-container>
												</tr>
												<tr *ngIf="edit==category.id" class="clickeable"
													(click)="addNewSubfamily(category.children)">
													<td colspan="3" class="bg-success" style="color:white">
														<i class="fa fa-plus"></i>Agregar nueva subfamilia
													</td>
												</tr>
											</tbody>
										</table>
									</td>
									<td class="ta">
										<span class="a-hover" (click)="editAndSave(category)">
											<i class="fa" *ngIf="!editing[category.id]"
												[ngClass]="edit==category.id?'fa-floppy-disk text-success':'fa-edit text-info'"></i>
											<span class="spinner-border spinner-border-sm"
												*ngIf="editing[category.id]"></span>
										</span>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>